// SearchInputSkeleton — Search Suspense fallback'i.
// useSearchParams resolve olana kadar görünür; input alanını placeholder eder.
"use client";

const SearchInputSkeleton = () => (
  <div className="relative">
    <div className="h-11 w-full rounded-md border border-input bg-background px-4 pr-28 flex items-center">
      <span className="text-muted-foreground text-sm select-none">Ara...</span>
    </div>
  </div>
);

export default SearchInputSkeleton;